"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const hooks_1 = require("../../../../../hooks");
const react_2 = tslib_1.__importDefault(require("react"));
exports.CampaignSendPageFeatureFlagToggle = ({ enable, }) => {
    if (!enable) {
        return null;
    }
    return react_2.default.createElement(exports.CampaignSendPageFeatureFlagToggleActive, null);
};
exports.CampaignSendPageFeatureFlagToggleActive = () => {
    const { featureFlags } = hooks_1.useOsmosysContext();
    return (react_2.default.createElement(react_1.OsmosysDiv, { flexColCentered: true },
        react_2.default.createElement(react_1.OsmosysToggler, { onLabel: "", offLabel: "Try the new campaign send page", on: featureFlags.newCampaignSendPage, id: "newCampaignSendPage", toggle: () => { } })));
};
//# sourceMappingURL=CampaignSendPageFeatureFlagToggle.js.map